import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router'
import { DOCUMENT_STATUS } from '../utils/Constants'
import { FormatDate } from '../utils/FormatDate'

const FormatDateYearMonth = dateString => {
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'short'
  })
}

const FormatDateHistory = dateString => {
  const date = new Date(dateString)
  return date.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}
const capitalizeFirst = str => str.charAt(0).toUpperCase() + str.slice(1)

export const DocumentList = ({ document, type, story }) => {
  const navigate = useNavigate()
  const handleViewDocument = async values => {
    navigate('/view-document', { state: { values } })
  }


  if (document && type && type === DOCUMENT_STATUS.STATUS_ON_HOLD) {
    return (
      <button
        onClick={() => handleViewDocument(document)}
        className='kl-document-link'
      >
        <div className='kl-document-on-hold'>
          <div className='kl-title-doc-content'>
            <span className='kl-name-doc'>{document.docName}</span>
            <p className='kl-doc-date'>
              {story
                ? FormatDateHistory(story.dcmtStDate)
                : FormatDate(document.docDateUpload)}
            </p>
            <div className='kl-doc-on-hold-type'>
              <svg
                width='9'
                height='10'
                viewBox='0 0 9 10'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M4.48926 9.03125C2.26926 9.03125 0.458008 7.22375 0.458008 5C0.458008 2.77625 2.26926 0.96875 4.48926 0.96875C6.70926 0.96875 8.52051 2.77625 8.52051 5C8.52051 7.22375 6.71301 9.03125 4.48926 9.03125ZM4.48926 1.53125C2.57676 1.53125 1.02051 3.0875 1.02051 5C1.02051 6.9125 2.57676 8.46875 4.48926 8.46875C6.40176 8.46875 7.95801 6.9125 7.95801 5C7.95801 3.0875 6.40176 1.53125 4.48926 1.53125Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M3.75375 6.48105H3.26625C2.92125 6.48105 2.71875 6.2823 2.71875 5.94855V4.05105C2.71875 3.7173 2.925 3.51855 3.26625 3.51855H3.75C4.095 3.51855 4.2975 3.7173 4.2975 4.05105V5.94855C4.30125 6.2823 4.095 6.48105 3.75375 6.48105ZM3.28125 5.91855H3.73875V4.08105H3.285L3.28125 5.91855Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M5.7334 6.48105H5.24965C4.90465 6.48105 4.70215 6.2823 4.70215 5.94855V4.05105C4.70215 3.7173 4.9084 3.51855 5.24965 3.51855H5.7334C6.0784 3.51855 6.2809 3.7173 6.2809 4.05105V5.94855C6.2809 6.2823 6.07465 6.48105 5.7334 6.48105ZM5.2609 5.91855H5.7184V4.08105H5.26465L5.2609 5.91855Z'
                  fill='#9CA3AF'
                />
              </svg>
              <span>{type}</span>
            </div>
          </div>
        </div>
      </button>
    )
  }

  if (document && type && type === DOCUMENT_STATUS.STATUS_ANALYSIS) {
    return (
      <button
        onClick={() => handleViewDocument(document)}
        className='kl-document-link'
      >
        <div className='kl-document-analyse'>
          <div className='kl-title-doc-content'>
            <span className='kl-name-doc'>{document.docName}</span>
            <p className='kl-doc-date'>
              <svg
                width='10'
                height='10'
                viewBox='0 0 10 10'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M3.74935 4.47917C3.11602 4.47917 2.60352 3.96667 2.60352 3.33333C2.60352 2.7 3.11602 2.1875 3.74935 2.1875C4.38268 2.1875 4.89518 2.7 4.89518 3.33333C4.89518 3.96667 4.38268 4.47917 3.74935 4.47917ZM3.74935 2.8125C3.46185 2.8125 3.22852 3.04583 3.22852 3.33333C3.22852 3.62083 3.46185 3.85417 3.74935 3.85417C4.03685 3.85417 4.27018 3.62083 4.27018 3.33333C4.27018 3.04583 4.03685 2.8125 3.74935 2.8125Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M6.25065 9.47933H3.75065C1.48815 9.47933 0.521484 8.51266 0.521484 6.25016V3.75016C0.521484 1.48766 1.48815 0.520996 3.75065 0.520996H5.41732C5.58815 0.520996 5.72982 0.662663 5.72982 0.833496C5.72982 1.00433 5.58815 1.146 5.41732 1.146H3.75065C1.82982 1.146 1.14648 1.82933 1.14648 3.75016V6.25016C1.14648 8.171 1.82982 8.85433 3.75065 8.85433H6.25065C8.17148 8.85433 8.85482 8.171 8.85482 6.25016V4.16683C8.85482 3.996 8.99648 3.85433 9.16732 3.85433C9.33815 3.85433 9.47982 3.996 9.47982 4.16683V6.25016C9.47982 8.51266 8.51315 9.47933 6.25065 9.47933Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M7.5 3.646C7.45833 3.646 7.42083 3.63766 7.37917 3.621C7.2625 3.57516 7.1875 3.4585 7.1875 3.3335V0.833496C7.1875 0.662663 7.32917 0.520996 7.5 0.520996C7.67083 0.520996 7.8125 0.662663 7.8125 0.833496V2.57933L8.1125 2.27933C8.23333 2.1585 8.43333 2.1585 8.55417 2.27933C8.675 2.40016 8.675 2.60016 8.55417 2.721L7.72083 3.55433C7.6625 3.61266 7.58333 3.646 7.5 3.646Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M7.50026 3.64577C7.42109 3.64577 7.34193 3.6166 7.27943 3.5541L6.44609 2.72077C6.32526 2.59994 6.32526 2.39993 6.44609 2.2791C6.56693 2.15827 6.76693 2.15827 6.88776 2.2791L7.72109 3.11243C7.84193 3.23327 7.84193 3.43327 7.72109 3.5541C7.65859 3.6166 7.57943 3.64577 7.50026 3.64577Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M1.11297 8.2084C1.01297 8.2084 0.912975 8.1584 0.854641 8.0709C0.758808 7.92923 0.796308 7.7334 0.942141 7.63756L2.99631 6.2584C3.44631 5.95423 4.06714 5.99173 4.47547 6.33757L4.61297 6.4584C4.82131 6.63756 5.17547 6.63756 5.37964 6.4584L7.11297 4.9709C7.55464 4.59173 8.25047 4.59173 8.69631 4.9709L9.37547 5.55423C9.50464 5.66673 9.52131 5.86257 9.40881 5.9959C9.29631 6.12507 9.10048 6.14173 8.96714 6.02923L8.28797 5.4459C8.07964 5.26673 7.72547 5.26673 7.51714 5.4459L5.78381 6.9334C5.34214 7.31256 4.64631 7.31256 4.20047 6.9334L4.06297 6.81257C3.87131 6.65007 3.55464 6.6334 3.34214 6.77923L1.28797 8.1584C1.23381 8.19173 1.17131 8.2084 1.11297 8.2084Z'
                  fill='#9CA3AF'
                />
              </svg>
                {story
                    ? FormatDateHistory(story.dcmtStDate)
                    : FormatDate(document.docDateUpload)}
            </p>
            <div className='kl-doc-analyse-type'>
              <svg
                width='9'
                height='10'
                viewBox='0 0 9 10'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M4.5 9.03125C2.27625 9.03125 0.46875 7.22375 0.46875 5C0.46875 4.115 0.75 3.275 1.2825 2.57C1.37625 2.44625 1.5525 2.42375 1.67625 2.5175C1.8 2.61125 1.82625 2.7875 1.7325 2.91125C1.275 3.515 1.03125 4.23875 1.03125 5C1.03125 6.9125 2.5875 8.46875 4.5 8.46875C6.4125 8.46875 7.96875 6.9125 7.96875 5C7.96875 3.0875 6.4125 1.53125 4.5 1.53125C4.34625 1.53125 4.21875 1.40375 4.21875 1.25C4.21875 1.09625 4.34625 0.96875 4.5 0.96875C6.72375 0.96875 8.53125 2.77625 8.53125 5C8.53125 7.22375 6.72375 9.03125 4.5 9.03125Z'
                  fill='#5379F6'
                />
                <path
                  d='M4.5 7.90625C2.89875 7.90625 1.59375 6.60125 1.59375 5C1.59375 4.84625 1.72125 4.71875 1.875 4.71875C2.02875 4.71875 2.15625 4.84625 2.15625 5C2.15625 6.29375 3.20625 7.34375 4.5 7.34375C5.79375 7.34375 6.84375 6.29375 6.84375 5C6.84375 3.70625 5.79375 2.65625 4.5 2.65625C4.34625 2.65625 4.21875 2.52875 4.21875 2.375C4.21875 2.22125 4.34625 2.09375 4.5 2.09375C6.10125 2.09375 7.40625 3.39875 7.40625 5C7.40625 6.60125 6.10125 7.90625 4.5 7.90625Z'
                  fill='#5379F6'
                />
                <path
                  d='M4.5 6.78125C4.34625 6.78125 4.21875 6.65375 4.21875 6.5C4.21875 6.34625 4.34625 6.21875 4.5 6.21875C5.17125 6.21875 5.71875 5.67125 5.71875 5C5.71875 4.32875 5.17125 3.78125 4.5 3.78125C4.34625 3.78125 4.21875 3.65375 4.21875 3.5C4.21875 3.34625 4.34625 3.21875 4.5 3.21875C5.4825 3.21875 6.28125 4.0175 6.28125 5C6.28125 5.9825 5.4825 6.78125 4.5 6.78125Z'
                  fill='#5379F6'
                />
              </svg>
              <span>{type}</span>
            </div>
          </div>
        </div>
      </button>
    )
  }

  if (document && type && type === DOCUMENT_STATUS.STATUS_ERROR) {
    return (
      <button
        onClick={() => handleViewDocument(document)}
        className='kl-document-link'
      >
        <div className='kl-document-error'>
          <div className='kl-title-doc-content'>
            <span className='kl-name-doc'>{document.docName}</span>
            <p className='kl-doc-date'>
              <svg
                width='10'
                height='10'
                viewBox='0 0 10 10'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M3.74935 4.47917C3.11602 4.47917 2.60352 3.96667 2.60352 3.33333C2.60352 2.7 3.11602 2.1875 3.74935 2.1875C4.38268 2.1875 4.89518 2.7 4.89518 3.33333C4.89518 3.96667 4.38268 4.47917 3.74935 4.47917ZM3.74935 2.8125C3.46185 2.8125 3.22852 3.04583 3.22852 3.33333C3.22852 3.62083 3.46185 3.85417 3.74935 3.85417C4.03685 3.85417 4.27018 3.62083 4.27018 3.33333C4.27018 3.04583 4.03685 2.8125 3.74935 2.8125Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M6.25065 9.47933H3.75065C1.48815 9.47933 0.521484 8.51266 0.521484 6.25016V3.75016C0.521484 1.48766 1.48815 0.520996 3.75065 0.520996H5.41732C5.58815 0.520996 5.72982 0.662663 5.72982 0.833496C5.72982 1.00433 5.58815 1.146 5.41732 1.146H3.75065C1.82982 1.146 1.14648 1.82933 1.14648 3.75016V6.25016C1.14648 8.171 1.82982 8.85433 3.75065 8.85433H6.25065C8.17148 8.85433 8.85482 8.171 8.85482 6.25016V4.16683C8.85482 3.996 8.99648 3.85433 9.16732 3.85433C9.33815 3.85433 9.47982 3.996 9.47982 4.16683V6.25016C9.47982 8.51266 8.51315 9.47933 6.25065 9.47933Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M7.5 3.646C7.45833 3.646 7.42083 3.63766 7.37917 3.621C7.2625 3.57516 7.1875 3.4585 7.1875 3.3335V0.833496C7.1875 0.662663 7.32917 0.520996 7.5 0.520996C7.67083 0.520996 7.8125 0.662663 7.8125 0.833496V2.57933L8.1125 2.27933C8.23333 2.1585 8.43333 2.1585 8.55417 2.27933C8.675 2.40016 8.675 2.60016 8.55417 2.721L7.72083 3.55433C7.6625 3.61266 7.58333 3.646 7.5 3.646Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M7.50026 3.64577C7.42109 3.64577 7.34193 3.6166 7.27943 3.5541L6.44609 2.72077C6.32526 2.59994 6.32526 2.39993 6.44609 2.2791C6.56693 2.15827 6.76693 2.15827 6.88776 2.2791L7.72109 3.11243C7.84193 3.23327 7.84193 3.43327 7.72109 3.5541C7.65859 3.6166 7.57943 3.64577 7.50026 3.64577Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M1.11297 8.2084C1.01297 8.2084 0.912975 8.1584 0.854641 8.0709C0.758808 7.92923 0.796308 7.7334 0.942141 7.63756L2.99631 6.2584C3.44631 5.95423 4.06714 5.99173 4.47547 6.33757L4.61297 6.4584C4.82131 6.63756 5.17547 6.63756 5.37964 6.4584L7.11297 4.9709C7.55464 4.59173 8.25047 4.59173 8.69631 4.9709L9.37547 5.55423C9.50464 5.66673 9.52131 5.86257 9.40881 5.9959C9.29631 6.12507 9.10048 6.14173 8.96714 6.02923L8.28797 5.4459C8.07964 5.26673 7.72547 5.26673 7.51714 5.4459L5.78381 6.9334C5.34214 7.31256 4.64631 7.31256 4.20047 6.9334L4.06297 6.81257C3.87131 6.65007 3.55464 6.6334 3.34214 6.77923L1.28797 8.1584C1.23381 8.19173 1.17131 8.2084 1.11297 8.2084Z'
                  fill='#9CA3AF'
                />
              </svg>
                {story
                    ? FormatDateHistory(story.dcmtStDate)
                    : FormatDate(document.docDateUpload)}
            </p>
            <div className='kl-doc-error-type'>
              <svg
                width='9'
                height='10'
                viewBox='0 0 9 10'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M6.9523 2.04494L4.8898 1.27244C4.67605 1.19369 4.3273 1.19369 4.11355 1.27244L2.05105 2.04494C1.65355 2.19494 1.33105 2.65994 1.33105 3.08369V6.12119C1.33105 6.42494 1.5298 6.82619 1.77355 7.00619L3.83605 8.54744C4.1998 8.82119 4.79605 8.82119 5.1598 8.54744L7.2223 7.00619C7.46605 6.82244 7.66481 6.42494 7.66481 6.12119V3.08369C7.66856 2.65994 7.34606 2.19494 6.9523 2.04494ZM5.5048 5.73869C5.44855 5.79494 5.3773 5.82119 5.30605 5.82119C5.2348 5.82119 5.16355 5.79494 5.1073 5.73869L4.51105 5.14244L3.89605 5.75744C3.8398 5.81369 3.76855 5.83994 3.6973 5.83994C3.62605 5.83994 3.5548 5.81369 3.49855 5.75744C3.3898 5.64869 3.3898 5.46869 3.49855 5.35994L4.11355 4.74494L3.51355 4.14494C3.4048 4.03619 3.4048 3.85619 3.51355 3.74744C3.6223 3.63869 3.8023 3.63869 3.91105 3.74744L4.5073 4.34369L5.08855 3.76244C5.1973 3.65369 5.3773 3.65369 5.48605 3.76244C5.5948 3.87119 5.5948 4.05119 5.48605 4.15994L4.9048 4.74119L5.50105 5.33744C5.61355 5.44994 5.61355 5.62619 5.5048 5.73869Z'
                  fill='#FF472B'
                />
              </svg>
              <span>{type}</span>
            </div>
          </div>
          <p className='kl-message-error-doc'>
            <FontAwesomeIcon icon={faCircleExclamation} />
            Le document est illisible, veuillez le reimporter
          </p>
        </div>
      </button>
    )
  }

  if (document && type && type === DOCUMENT_STATUS.STATUS_TREATED) {
    return (
      <button
        onClick={() => handleViewDocument(document)}
        className='kl-document-link'
      >
        <div className='kl-document-treated'>
          <div className='kl-title-doc-content'>
            <span className='kl-name-doc'>{document.docName}</span>
            <p className='kl-doc-date'>
              <svg
                width='10'
                height='10'
                viewBox='0 0 10 10'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M3.74935 4.47917C3.11602 4.47917 2.60352 3.96667 2.60352 3.33333C2.60352 2.7 3.11602 2.1875 3.74935 2.1875C4.38268 2.1875 4.89518 2.7 4.89518 3.33333C4.89518 3.96667 4.38268 4.47917 3.74935 4.47917ZM3.74935 2.8125C3.46185 2.8125 3.22852 3.04583 3.22852 3.33333C3.22852 3.62083 3.46185 3.85417 3.74935 3.85417C4.03685 3.85417 4.27018 3.62083 4.27018 3.33333C4.27018 3.04583 4.03685 2.8125 3.74935 2.8125Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M6.25065 9.47933H3.75065C1.48815 9.47933 0.521484 8.51266 0.521484 6.25016V3.75016C0.521484 1.48766 1.48815 0.520996 3.75065 0.520996H5.41732C5.58815 0.520996 5.72982 0.662663 5.72982 0.833496C5.72982 1.00433 5.58815 1.146 5.41732 1.146H3.75065C1.82982 1.146 1.14648 1.82933 1.14648 3.75016V6.25016C1.14648 8.171 1.82982 8.85433 3.75065 8.85433H6.25065C8.17148 8.85433 8.85482 8.171 8.85482 6.25016V4.16683C8.85482 3.996 8.99648 3.85433 9.16732 3.85433C9.33815 3.85433 9.47982 3.996 9.47982 4.16683V6.25016C9.47982 8.51266 8.51315 9.47933 6.25065 9.47933Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M7.5 3.646C7.45833 3.646 7.42083 3.63766 7.37917 3.621C7.2625 3.57516 7.1875 3.4585 7.1875 3.3335V0.833496C7.1875 0.662663 7.32917 0.520996 7.5 0.520996C7.67083 0.520996 7.8125 0.662663 7.8125 0.833496V2.57933L8.1125 2.27933C8.23333 2.1585 8.43333 2.1585 8.55417 2.27933C8.675 2.40016 8.675 2.60016 8.55417 2.721L7.72083 3.55433C7.6625 3.61266 7.58333 3.646 7.5 3.646Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M7.50026 3.64577C7.42109 3.64577 7.34193 3.6166 7.27943 3.5541L6.44609 2.72077C6.32526 2.59994 6.32526 2.39993 6.44609 2.2791C6.56693 2.15827 6.76693 2.15827 6.88776 2.2791L7.72109 3.11243C7.84193 3.23327 7.84193 3.43327 7.72109 3.5541C7.65859 3.6166 7.57943 3.64577 7.50026 3.64577Z'
                  fill='#9CA3AF'
                />
                <path
                  d='M1.11297 8.2084C1.01297 8.2084 0.912975 8.1584 0.854641 8.0709C0.758808 7.92923 0.796308 7.7334 0.942141 7.63756L2.99631 6.2584C3.44631 5.95423 4.06714 5.99173 4.47547 6.33757L4.61297 6.4584C4.82131 6.63756 5.17547 6.63756 5.37964 6.4584L7.11297 4.9709C7.55464 4.59173 8.25047 4.59173 8.69631 4.9709L9.37547 5.55423C9.50464 5.66673 9.52131 5.86257 9.40881 5.9959C9.29631 6.12507 9.10048 6.14173 8.96714 6.02923L8.28797 5.4459C8.07964 5.26673 7.72547 5.26673 7.51714 5.4459L5.78381 6.9334C5.34214 7.31256 4.64631 7.31256 4.20047 6.9334L4.06297 6.81257C3.87131 6.65007 3.55464 6.6334 3.34214 6.77923L1.28797 8.1584C1.23381 8.19173 1.17131 8.2084 1.11297 8.2084Z'
                  fill='#9CA3AF'
                />
              </svg>
                {story
                    ? FormatDateHistory(story.dcmtStDate)
                    : FormatDate(document.docDateUpload)}
            </p>
            <div className='kl-doc-treated-type'>
              <svg
                width='9'
                height='10'
                viewBox='0 0 9 10'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M6.07125 1.25H2.92875C1.56375 1.25 0.75 2.06375 0.75 3.42875V6.5675C0.75 7.93625 1.56375 8.75 2.92875 8.75H6.0675C7.4325 8.75 8.24625 7.93625 8.24625 6.57125V3.42875C8.25 2.06375 7.43625 1.25 6.07125 1.25ZM6.2925 4.1375L4.16625 6.26375C4.11375 6.31625 4.0425 6.34625 3.9675 6.34625C3.8925 6.34625 3.82125 6.31625 3.76875 6.26375L2.7075 5.2025C2.59875 5.09375 2.59875 4.91375 2.7075 4.805C2.81625 4.69625 2.99625 4.69625 3.105 4.805L3.9675 5.6675L5.895 3.74C6.00375 3.63125 6.18375 3.63125 6.2925 3.74C6.40125 3.84875 6.40125 4.025 6.2925 4.1375Z'
                  fill='#60C631'
                />
              </svg>
              <span>{type}</span>
            </div>
          </div>
          {document.isSubmit === true &&  (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div className='kl-red-flag-document'>
                <span>soumis</span>
              </div>
            </div>
          )}

          <div className='kl-treaded-content mt-3'>
            <span>
              commercant <br />{' '}
              <strong className='kl-treaded-strong mt-2'>Total</strong>
            </span>
            <span>
              Date document <br />{' '}
              <strong className='kl-treaded-strong mt-2'>
                {capitalizeFirst(FormatDateYearMonth(document.docDateUpload))}
              </strong>
            </span>
            <div className='kl-treaded-type-end'>
                {document.docType < 4 &&  (
                    <span>Dépense </span>
                )}
              <br />
              <span className='kl-treaded-abonnement'>Abonnement</span>
            </div>
          </div>
        </div>
      </button>
    )
  }
}
